export function decodeBase64Json<T>(base64: string): T | undefined {

  try {

    const jsonText = typeof Buffer !== 'undefined'
      ? Buffer.from(base64, 'base64').toString('utf8')
      : atob(base64);

    return JSON.parse(jsonText) as T;

  } catch {

    return undefined;

  }

}
